export default {
  init() {
    const questionsList = document.getElementById('js-questions');
    const questions = Array.from(questionsList.querySelectorAll('.js-question'));
    const thematiqueFilters = document.getElementById('js-thematiques-filters');
    if (!thematiqueFilters) return;
    thematiqueFilters.addEventListener('click', (e) => {
      const target = e.target;
      if (target.classList.contains('js-thematique-filter')) {
        thematiqueFilters
          .querySelectorAll('.js-thematique-filter')
          .forEach((filter) => (target === filter ? null : filter.classList.remove('active')));
        if (target.classList.contains('active')) {
          target.classList.remove('active');
          questions.forEach((question) => {
            question.classList.remove('!hidden');
          });
        } else {
          target.classList.add('active');
          questions.forEach((question) => {
            if (!question.getAttribute('term_ids').includes(target.getAttribute('term-id'))) {
              question.classList.add('!hidden');
            } else {
              question.classList.remove('!hidden');
            }
          });
        }
      }
    });
  },
};
